import angular from 'angular';
import AnnouncementPreviewComponent from './announcement-preview-component';

export default angular.module('announcement-preview', []).component('announcementPreview', new AnnouncementPreviewComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/announcements/components/announcement-preview/announcement-preview-module.js